<div class="menu-button" [matMenuTriggerFor]="languageMenu">
    <span class="country">
        <span class="fi fi-{{ selectedLanguage.flag }}"></span>
        <span>{{ selectedLanguage.name }}</span>
    </span>
    <mat-icon>keyboard_arrow_down</mat-icon>
</div>
<mat-menu #languageMenu="matMenu">
    <ng-container *ngFor="let language of languages">
        <button mat-menu-item (click)="setCurrentLanguage(language)">
            <span class="country">
                <span class="fi fi-{{ language.flag }}"></span>
                <span>{{ language.name }}</span>
            </span>
        </button>
    </ng-container>
</mat-menu>
